import {Link} from 'react-router-dom'

export default function Navbar() {
    <nav>
        <Link to='/'>Home</Link>
        <Link to='/applynow'>Apply Now</Link>
        <Link to='/trafficcontrol'>Traffic Control</Link>
        </nav>
}
